import { memo } from 'react'
import classNames from 'classnames'
import { useSelector, shallowEqual } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'

const ScrollDown = ({
  classes,
  className,
  color,
  onClick,
}) => {
  /*------------------------------
  Redux Connect
  ------------------------------*/
  const { strings } = useSelector((state) => ({
    strings: state.options.strings,
  }), shallowEqual)

  return (
    <button
      className={classNames({
        [classes.root]: true,
        [classes.rootColorLight]: color === 'light',
        [classes.rootColorDark]: color === 'dark',
        [className]: className,
      })}
      onClick={onClick}
      aria-label="scroll-down"
    >
      <span className={classes.text}>{strings.scroll_label}</span>
      <div className={classes.circle}>
        <div className={classes.arrow} />
      </div>
    </button>
  )
}

ScrollDown.defaultProps = {
  color: 'light',
}

export default injectSheet(style)(memo(ScrollDown))
